
import {defineComponent, PropType} from "vue";

export default defineComponent({
  name: "ButtonTab",
  props: {
    title: {
      type: String,
      required: true
    },
    isActive: {
      type: Boolean,
      required: true
    },
    type: {
      type: String as PropType<"annotation" | "content">,
      required: true
    }
  }
});
